module.exports = __webpack_public_path__ + "static/media/suzuki_logo.c211e9a4.png";